import { useEffect } from 'react';
import { wsClient } from '../services/websocket';
import { directFileTransferManager } from '../services/directFileTransfer';
import type {
  WSDirectFileTransferAcceptedData,
  WSDirectFileTransferEndedData,
  WSDirectFileTransferIceCandidateData,
  WSDirectFileTransferIncomingData,
  WSDirectFileTransferRejectedData
} from '@shared/types';

export function useDirectFileTransferListeners() {
  useEffect(() => {
    const unsubIncoming = wsClient.on('file-transfer:incoming', (message) => {
      directFileTransferManager.handleIncomingOffer(message.data as WSDirectFileTransferIncomingData);
    });
    const unsubAccepted = wsClient.on('file-transfer:accepted', async (message) => {
      await directFileTransferManager.handleAccepted(message.data as WSDirectFileTransferAcceptedData);
    });
    const unsubRejected = wsClient.on('file-transfer:rejected', (message) => {
      directFileTransferManager.handleRejected(message.data as WSDirectFileTransferRejectedData);
    });
    const unsubIce = wsClient.on('file-transfer:ice-candidate', async (message) => {
      await directFileTransferManager.handleIceCandidate(message.data as WSDirectFileTransferIceCandidateData);
    });
    const unsubEnded = wsClient.on('file-transfer:ended', (message) => {
      const data = message.data as WSDirectFileTransferEndedData;
      directFileTransferManager.handleEnded(data.sessionId, data.reason);
    });

    return () => {
      unsubIncoming();
      unsubAccepted();
      unsubRejected();
      unsubIce();
      unsubEnded();
    };
  }, []);
}
